/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Rules mismatch: specific document field
 * @export
 * @interface PaxCheckFieldMismatch
 */
export interface PaxCheckFieldMismatch {
    /**
     * Name of the mismatched document field
     * @type {string}
     * @memberof PaxCheckFieldMismatch
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckFieldMismatch
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckFieldMismatch interface.
 */
export function instanceOfPaxCheckFieldMismatch(value: object): value is PaxCheckFieldMismatch {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckFieldMismatchFromJSON(json: any): PaxCheckFieldMismatch {
    return PaxCheckFieldMismatchFromJSONTyped(json, false);
}

export function PaxCheckFieldMismatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckFieldMismatch {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'type': json['type'],
    };
}

export function PaxCheckFieldMismatchToJSON(json: any): PaxCheckFieldMismatch {
    return PaxCheckFieldMismatchToJSONTyped(json, false);
}

export function PaxCheckFieldMismatchToJSONTyped(value?: PaxCheckFieldMismatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'type': value['type'],
    };
}

